/* eslint-disable no-mixed-operators */
/* eslint-disable no-unused-vars */

import $ from 'jquery';
import bar from 'britecharts/dist/umd/bar.min';
import rangeslider from 'rangeslider.js';
import drawChart from './barchart';

const d3Selection = require('d3-selection');

function updateTooltip(pos, inputValue, context) {
    const value = inputValue || context.value;
    const $tooltip = $('.rangeslider__tooltip', context.$range);
    if ($tooltip.length) {
        if (context.$element.data('for') === 'initialDeposit' || context.$element.data('for') === 'monthlyDeposit') {
            $tooltip[0].innerHTML = `$${String(value).replace(/\d(?=(?:\d{3})+$)/g, '$&,')}`;
        } else if (context.$element.data('for') === 'years') {
            $tooltip[0].innerHTML = `Over ${value} years`;
        } else {
            $tooltip[0].innerHTML = value;
        }
    }
}

function getReturns(amount, years, deposit, generic = false, bank = false) {
    // Compound interest for principal: D*(1 + i)n = amount * costs
    // Future value of a series: A*((1+i)n-1) / i) = deposit * ( (costs - 1) / rate

    const n = 12;
    let rate;
    if (generic) {
        rate = 0.045 / n;
    } else if (bank) {
        rate = 0.03 / n;
    } else {
        rate = 0.0625 / n;
    }

    const costs = (1 + rate) ** (years * n);

    return Math.ceil(
        (amount * costs) + (deposit * ((costs - 1) / rate)),
    );
}


function updateDataChart(chart, container, inputAmount, inputYears, inputDeposit) {
    const sixparkBar = { value: getReturns(inputAmount, inputYears, inputDeposit), name: 'Six Park' };
    const genericBar = { value: getReturns(inputAmount, inputYears, inputDeposit, true, false), name: 'Generic \n Stockbroker \nAdvice' };
    const bankBar = { value: getReturns(inputAmount, inputYears, inputDeposit, false, true), name: 'High Interest \n Savings \n Account' };

    $('.percentage-label-group').remove();
    $('.bar__line').remove();
    const dataChart = [];
    dataChart.push(bankBar, genericBar, sixparkBar);

    container.datum(dataChart).call(chart);


    drawChart();
}


function updateReturns(inputAmount, inputYears, monthlyDeposit, savingOutput, yearsOutput, age) {
    const sixparkReturns = getReturns(inputAmount, inputYears, monthlyDeposit);
    const genericReturns = getReturns(inputAmount, inputYears, monthlyDeposit, true, false);
    const bankReturns = getReturns(inputAmount, inputYears, monthlyDeposit, false, true);
    const savingReturns = sixparkReturns - genericReturns;

    savingOutput.text(`+$${savingReturns}`.replace(/\d(?=(?:\d{3})+$)/g, '$&,'));
    yearsOutput.text(inputYears + age);
}

function setupChart(barChart, container) {
    const width = container.node() ? container.node().getBoundingClientRect().width : false;
    const height = container.node() ? container.node().getBoundingClientRect().height : false;

    barChart
        .margin({
            left: 0,
            right: 0,
            top: 50,
            bottom: 30,
        })
        .width(width)
        .height(height)
        .enablePercentageLabels(true)
        // .isAnimated(true)
        .yTicks(0)
        .percentageLabelMargin(25)
        .yAxisPaddingBetweenChart(0);
}


export default (container, age) => {
    const $container = $(container);

    const $monthlyDeposit = $container.find('[data-for="monthlyDeposit"]');
    const $inputAmount = $container.find('[data-for="initialDeposit"]');
    const $inputYears = $container.find('[data-for="years"]');

    const $outputSaving = $container.find('[data-for="saving"]');
    const $outputYears = $container.find('[data-for="futureYears"]');

    // Init barChart
    const barChart = bar();
    const $barContainer = d3Selection.select('.js-calculator-chart');
    setupChart(barChart, $barContainer);

    $container.find('input[type="range"]').rangeslider({
        polyfill: false,
        onInit() {
            const tooltip = '<div class="rangeslider__tooltip"></div>';
            this.$handle.append($(tooltip));
            updateTooltip(null, null, this);
            updateReturns(Number($inputAmount.val()), Number($inputYears.val()), Number($monthlyDeposit.val()), $outputSaving, $outputYears, age);
            updateDataChart(barChart, $barContainer, Number($inputAmount.val()), Number($inputYears.val()), Number($monthlyDeposit.val()));
        },
        onSlide(pos, value) {
            updateTooltip(pos, value, this);
            updateReturns(Number($inputAmount.val()), Number($inputYears.val()), Number($monthlyDeposit.val()), $outputSaving, $outputYears, age);
            updateDataChart(barChart, $barContainer, Number($inputAmount.val()), Number($inputYears.val()), Number($monthlyDeposit.val()));
        },
    });
};




// WEBPACK FOOTER //
// ./app/scripts/components/calculator-barchart.js